import { useQuery } from 'react-query';
import httpClient from '../datasources/httpClient';

export default function useQueryWorkspaces() {
  return useQuery(
    'workspaces',
    async () => {
      const response = await httpClient.get('workspaces');

      return response.data;
    },
    {
      staleTime: 10000 * 60,
    },
  );
}
